import "./PipeRepair.module.css";
import Header from "@/reusable_sections/Header";
import PipeHero from "./sections/PipeHero";
import PipeRepair from "./sections/PipeRepair";
import PipeTriage from "./sections/PipeTriage";
import WarningSigns from "./sections/WarningSigns";
import PipeDiagnostics from "./sections/PipeDiagnostics";
import Coreservices from "./sections/Coreservices";
import ProblemCategories from "./sections/ProblemCategories";
import ServiceArea from "./sections/ServiceArea";
import PipeFaq from "./sections/PipeFaq";
import EmergencyCta from "./sections/EmergencyCta";
import Footer from "@/reusable_sections/Footer";
export default function PipeRepairPage() {
  return <div>
      <Header />
      <PipeHero />
      <PipeRepair />
      <PipeTriage />
      <WarningSigns />
      <PipeDiagnostics />
      <Coreservices />
      <ProblemCategories />
      <ServiceArea />
      <PipeFaq />
      <EmergencyCta />
      <Footer />
    </div>;
}